import { AnchoredPanel, AnchoredPanelComponent, BookmarkablePage, useNavigation } from "o4a-react";
import * as React from "react";
import * as Messages from "../../codegen/Messages";
import { ConsoleContext } from "../../console/ConsoleContext";
import { PageId, PageRegistrationConfig, SUPPORT_ROUTE } from "../../constants/pluginConstants";
import { SupportList } from "./SupportList";

const registrationIds = PageRegistrationConfig[PageId.SUPPORT].map(config => config.key);

export const SupportListPage = (): JSX.Element => {
  const { back, navigateToSelf } = useNavigation(ConsoleContext);

  const [panelRef, setPanelRef] = React.useState<AnchoredPanelComponent>({} as AnchoredPanelComponent);

  React.useEffect(() => {
    // In case page was navigated to directly by entring its URL in the browser
    navigateToSelf(SUPPORT_ROUTE, registrationIds[0]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <BookmarkablePage
      appContext={ConsoleContext}
      registrationIds={registrationIds}
      title={Messages.listSupport.titles.short()}
    >
      <AnchoredPanel
        anchorId="page"
        componentRef={setPanelRef}
        title={Messages.listSupport.titles.long()}
        icon="support-svg"
        onClose={back}
        isOpen
      >
        <SupportList panelRef={panelRef} />
      </AnchoredPanel>
    </BookmarkablePage>
  );
};
